import { DeliveryZone } from '@delivery/const';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { DeliveryState, StateWithDelivery } from '../delivery-state';
import { getDeliveryState } from './state.selectors';

export const getDeliveryZones = (id: string): MemoizedSelector<StateWithDelivery, DeliveryZone[]> =>
  createSelector(getDeliveryState, (state: DeliveryState) => StateUtils.entityValueSelector(state.deliveryZones, id));
